<template>
  <div>
    <router-view></router-view>
    <bottomUrl />
  </div>
</template>
<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';

export default {
  components: {
    bottomUrl,
  },
};
</script>